import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "channel-inbox",
  "use": "channel-inbox-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"channel-inbox\"><path d=\"M12.75 18.75v4.5m-9-15h16.5a3 3 0 013 3V18a.75.75 0 01-.75.75H6.75m-3-10.5a3 3 0 013 3v7.5m-3-10.5a3 3 0 00-3 3V18c0 .414.336.75.75.75h5.25m4.5-7.5V.75m0 0h5.25a2.25 2.25 0 010 4.5h-5.25V.75z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/channel-inbox.svg
// module id = fKMB
// module chunks = 39 44